module.exports = __webpack_public_path__ + "img/dismorfia.bb179733.png";